export default __webpack_public_path__ + "static/media/Fondo-azul.e73b1da8.png";